import {
  storeDetailRows,
  StoreDetailsFacts,
  StoreRailBlock,
} from "@softmax/product-ux/catalog";
import type { PreviewContent } from "../content/preview-content.types";

import { LockedRegion } from "../../store-editor";

export function StoreDetails({
  content,
  sentenceCaseLabel = false,
}: {
  content: PreviewContent;
  sentenceCaseLabel?: boolean;
}) {
  const rows = storeDetailRows(content.details);
  const tags = content.details.tags;

  if (rows.length === 0 && tags.length === 0) return null;

  return (
    <StoreRailBlock label="Details">
      <LockedRegion label="Set via the coworld manifest">
        <StoreDetailsFacts
          rows={rows}
          tags={tags}
          sentenceCaseLabel={sentenceCaseLabel}
        />
      </LockedRegion>
    </StoreRailBlock>
  );
}
